/* unplugin-vue-components disabled */import { render } from "./aboutLink.vue?vue&type=template&id=2d31eb6d&scoped=true"
import script from "./aboutLink.vue?vue&type=script&lang=js"
export * from "./aboutLink.vue?vue&type=script&lang=js"

import "./aboutLink.vue?vue&type=style&index=0&id=2d31eb6d&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上海杉达-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d31eb6d"]])

export default __exports__